import React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import {
  Button,
  ButtonWidth,
} from '@practicegenius/pg-ui/src/base/Material/components/Button';
import {Link} from '../../../components/Link';

export function GenericErrorModal({
  open,
  close,
}: {
  open: boolean;
  close: () => unknown;
}) {
  return (
    <Dialog open={open} onClose={close}>
      <DialogTitle>It's not you - it's us!</DialogTitle>
      <DialogContent>
        Please give us a call at{' '}
        <Link href="tel:800-560-1469">(800) 560-1469</Link> and we'll help fix
        this unexpected error as soon as possible.
      </DialogContent>
      <DialogActions>
        <Button color="primary" width={ButtonWidth.WIDE} onClick={close}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
